import { getNewMappedStatus } from 'KnmErpPackage/MainModule/common/getNewMappedStatus';

import { RenderFunc } from '../types/RenderFunc';

export const renderStatusName: RenderFunc = (item, termsData) => {
  const { newValue, oldValue } = item;

  if (termsData && 'isErp' in termsData && termsData?.isErp) {
    const { isReasonsImpossibility } = termsData;

    return {
      renderedOldValue: typeof oldValue === 'string' ? getNewMappedStatus(oldValue, isReasonsImpossibility) : '',
      renderedNewValue: typeof newValue === 'string' ? getNewMappedStatus(newValue, isReasonsImpossibility) : '',
    };
  }

  return {
    renderedOldValue: typeof oldValue === 'string' ? oldValue : '',
    renderedNewValue: typeof newValue === 'string' ? newValue : '',
  };
};
